(function (angular) {
    'use strict';

    angular.module('whatsApp')
        /**
         *
         */
        .controller('whatsAppBusinessProfileController',
        ['$scope', 'whatsAppServices', 'whatsAppConfig', '$stateParams', 'growlService', '$uibModalInstance', 'uploadFileService', '$q', 'utilService',
            function ($scope, whatsAppServices, whatsAppConfig, $stateParams, growlService, $uibModalInstance, uploadFileService, $q, utilService) {
                $scope.vertical = [
                    "Automotive",
                    "Beauty, Spa and Salon",
                    "Clothing and Apparel",
                    "Education",
                    "Entertainment",
                    "Event Planning and Service",
                    "Finance and Banking",
                    "Food and Grocery",
                    "Public Service",
                    "Hotel and Lodging",
                    "Medical and Health",
                    "Non-profit",
                    "Professional Services",
                    "Shopping and Retail",
                    "Travel and Transportation",
                    "Restaurant",
                    "Other"
                ]
                $scope.validateEmail = function(){
                    return utilService.validateEmail($scope.whatsAppData.email);
                }
                $scope.validateUrl =  function(){
                    return utilService.validateUrl($scope.whatsAppData.website, true);
                }
                
                $scope.validate = function(){
                    return $scope.validateEmail() && $scope.validateUrl();
                }
                $scope.phoneNumber = whatsAppConfig.phoneNumber;
                var whatsAppCurrentData = whatsAppConfig.profile || {};
                $scope.whatsAppData = angular.copy(whatsAppCurrentData);
                $scope.whatsAppData.website = $scope.whatsAppData.websites ? $scope.whatsAppData.websites[0] : "";
                delete $scope.whatsAppData.websites;
                $scope.cancelWhatsAppUpdate = function(){
                    $uibModalInstance.dismiss('cancel');
                };
            
                $scope.updateWhatsApp = function(){
                    var data = {
                        about: $scope.whatsAppData.about,
                        address: $scope.whatsAppData.address,
                        description: $scope.whatsAppData.description,
                        email: $scope.whatsAppData.email,
                        vertical: $scope.whatsAppData.vertical,
                        websites: [$scope.whatsAppData.website],
                    }
                    whatsAppServices.updateBusinessProfile($stateParams.pickedApiSpaceId, $scope.phoneNumber, data)
                    .then(function(config){
                        updatePhoto()
                            .then(function(result){
                                whatsAppConfig.profile = data;
                                whatsAppConfig.profile.photoUrl = $scope.whatsAppData.photoUrl;
                                growlService.success('WhatsApp Config set');
                                $uibModalInstance.close('save');
                            })
                            .catch(function(error){
                                growlService.danger("WhatsApp Image wasn't set due to: "+error.statusText);
                            });
                        
                    }).catch(function(error){
                        growlService.danger("WhatsApp Config wasn't set due to: "+error.statusText);
                    });
                };

                $scope.updateImage = function(){
                    uploadFileService.uploadFile("", false, null, {
                        minWidth: 200,
                        minHeight: 200
                    })
                        .then(function (uploadResult) {
                            $scope.whatsAppData.photoUrl = uploadResult.url;
                        }).catch(function(error){
                            growlService.danger("Image wasn't uploaded due to: "+error.statusText);
                        });
                };
                function updatePhoto(){
                    if($scope.whatsAppData.photoUrl !== whatsAppCurrentData.photoUrl && !$scope.whatsAppData.photoUrl){
                        return whatsAppServices.deleteBusinessProfilePhoto($stateParams.pickedApiSpaceId, $scope.phoneNumber);
                    } else if($scope.whatsAppData.photoUrl !== whatsAppCurrentData.photoUrl && $scope.whatsAppData.photoUrl) {
                        return whatsAppServices.updateBusinessProfilePhoto($stateParams.pickedApiSpaceId, $scope.phoneNumber, $scope.whatsAppData.photoUrl)
                    } else {
                        return $q.resolve();
                    }
                }
                $scope.deleteImage = function(){
                    delete $scope.whatsAppData.photoUrl;
                }
        }]);


})(window.angular);
